export default {
      id: "vacancy-usage",
      viewBox: "0 0 1600 1600",
      url: __webpack_public_path__ + "app/svg/sprite.svg#vacancy",
      toString: function () {
        return this.url;
      }
    }